import * as React from "react";
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28", width: 28, height: 28, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m25.39 7.31-8.83 10.92-6.02-5.47-7.16 8.56-.76-.64 7.82-9.36 6 5.45L24.61 6.7l.78.62Z" }));
export default SvgLine;
